<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">行銷活動 / 首頁廣告管理</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
          <router-link :to="{ name: 'advertising_add', params: { search: search } }" class="btn btn-normal-ptc1" tag="button" v-if="FunctionPermission > 1">新增廣告</router-link>
        </div>
      </b-col>
    </b-row>

    <div id="func-content">
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2">活動標題：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="search.title" placeholder="請輸入關鍵字搜尋">
                  </div>
                </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2">效期區間：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="search.sdate" max="9999-12-31" @input="changeDate($event, 1)" v-on:keydown="keydownDate($event, 1)">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="search.edate" :min="search.sdate" max="9999-12-31" @input="changeDate($event, 2)" v-on:keydown="keydownDate($event, 2)">
                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                    <button type="button" class="btn btn-ptc1" @click="reset">重設</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>

      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <b-tabs card class="tab_color" v-model="search.tabIndex">
              <b-tab title="上架中" @click="changeTab(0)">
                <div class="row">
                  <div class="col-lg-6">
                    <h3>首頁排序</h3>
                  </div>
                  <div class="col-lg-6">
                    <div class="float-right" v-show="!isReSort">
                      <button type="button" class="btn btn-ptc1" @click="resort" v-if="FunctionPermission > 1">重新排序</button>
                    </div>
                    <div class="float-right" v-show="isReSort">
                      <button type="button" class="btn btn-save" @click="save">儲存</button>
                      <button type="button" class="btn btn-clear" @click="cancel">取消</button>
                    </div>
                  </div>
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped" :class="{ 'table-move': isReSort }">
                        <thead>
                          <tr>
                            <th>序號</th>
                            <th>圖片</th>
                            <th>標題</th>
                            <th>開始日期</th>
                            <th>結束日期</th>
                            <th>狀態</th>
                            <th>異動人員</th>
                            <th>異動時間</th>
                            <th></th>
                          </tr>
                        </thead>
                        <draggable element="tbody" :options="{ 'disabled': !isReSort }" @update="dragEnd">
                          <tr v-for="(x, index) in items" :key="x.ID" :id="x.ID">
                            <td>{{pageRows * (search.currentPage - 1) + index + 1}}</td>
                            <td><img height="140px" :src="x.ImageURL"></td>
                            <td>{{x.Title}}</td>
                            <td>{{x.EnabledAt | formatDate}}</td>
                            <td>{{x.DisabledAt | formatDate}}</td>
                            <td>
                              <span v-if="x.Status==0">草稿</span>
                              <span v-else-if="x.Status==1&&x.EnabledAt.substring(0,10)>today">已排程</span>
                              <span v-else style="color:red">已上架</span>
                            </td>
                            <td>{{x.UpdatedName}}</td>
                            <td>{{x.WebUpdatedAt | formatFullDate}}</td>
                            <td>
                              <router-link v-b-tooltip.hover.top title="編輯" class="btn-circle btn-circle-ptc1" tag="button" :to="{ name: 'advertising_edit', params: { item: x, action: 1, search: search } }" v-show="!isReSort" v-if="FunctionPermission > 1"><span class="fa fa-pencil-alt"></span></router-link>
                              <button v-b-tooltip.hover.top title="預覽" class="btn-circle btn-circle-ptc1" @click="showDetail(x)"><span class="fa fa-search-plus"></span></button>
                            </td>
                          </tr>
                        </draggable>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination size="md" :total-rows="totalRows" v-model="search.currentPage" :per-page="pageRows" @change="changePage"></b-pagination>
                      <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalRows}}筆</label>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab title="已下架" @click="changeTab(1)">
                <div class="row">
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped">
                        <thead>
                          <tr>
                            <th>序號</th>
                            <th>圖片</th>
                            <th>標題</th>
                            <th>開始日期</th>
                            <th>結束日期</th>
                            <th>異動人員</th>
                            <th>異動時間</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(x, index) in items" :key="x.ID">
                            <td>{{pageRows * (search.currentPage - 1) + index + 1}}</td>
                            <td><img height="140px" :src="x.ImageURL"></td>
                            <td>{{x.Title}}</td>
                            <td>{{x.EnabledAt | formatDate}}</td>
                            <td>{{x.DisabledAt | formatDate}}</td>
                            <td>{{x.UpdatedName}}</td>
                            <td>{{x.WebUpdatedAt | formatFullDate}}</td>
                            <td>
                              <router-link v-b-tooltip.hover.top title="編輯" class="btn-circle btn-circle-ptc1" tag="button" :to="{ name: 'advertising_edit', params: { item: x, action: 2, search: search } }" v-if="FunctionPermission > 1"><span class="fa fa-pencil-alt"></span></router-link>
                              <button v-b-tooltip.hover.top title="刪除" class="btn-circle btn-circle-ptc1" @click="showDelete(x)" v-if="FunctionPermission > 1"><span class="fas fa-trash-alt"></span></button>
                              <button v-b-tooltip.hover.top title="預覽" class="btn-circle btn-circle-ptc1" @click="showDetail(x)"><span class="fa fa-search-plus"></span></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination size="md" :total-rows="totalRows" :per-page="pageRows" @change="changePage"></b-pagination>
                      <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalRows}}筆</label>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </b-card>

      <!-- 預覽畫面Modal -->
      <b-modal ref="mdDetail" hide-footer hide-header>
        <b-container fluid>
          <div class="row">
            <div class="col-lg-12 block">
              <img class="front_img" src="../../../assets/preview/phone.png">
              <div class="bk_div">
                <img class="bk_img" :src="md_imgUrl">
              </div>
            </div>
          </div>
        </b-container>
      </b-modal>

      <!-- ReSort Check Modal -->
      <b-modal ref="mdCheck" hide-footer title="首頁排序變更">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定 {{sort_action==1? '放棄' : '儲存'}} 首頁排序變更 ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="confirm2">確定</b-btn>
              <b-btn variant="secondary" @click="cancel2">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>

      <!-- Delete Check Modal -->
      <b-modal ref="mdDelete" hide-footer title="首頁廣告刪除">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定刪除廣告 {{md_title}} ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="delConfirm">確定</b-btn>
              <b-btn variant="secondary" @click="delCancel">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>

    </div>
  </div>
</template>
<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script src="//cdn.jsdelivr.net/npm/sortablejs@1.7.0/Sortable.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.15.0/vuedraggable.min.js"></script>
<script>
import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import draggable from 'vuedraggable'
import VModal from 'vue-js-modal'
import axios from 'axios'
miniToastr.init()
export default {
  components: {
    draggable
  },
  data () {
    return {
      search: {
        title: '',
        sdate: '',
        edate: '',
        tabIndex: 0,
        currentPage: 1
      },
      today: '',
      sdateInvalid: false,
      edateInvalid: false,
      isReSort: false,
      totalRows: 0,
      pageRows: 20,
      startRowNum: 0,
      endRowNum: 0,
      items: [],
      sort_action: 1,
      sort_list: [],
      md_id: 0,
      md_title: '',
      md_imgUrl: undefined,
      API_URL: API_URL,
      FunctionPermission: 0
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F04') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }

    var date = new Date()
    var year = date.getFullYear()
    var mon = date.getMonth() + 1
    var day = date.getDate()

    if (mon < 10) {
      mon = '0' + mon
    }
    if (day < 10) {
      day = '0' + day
    }
    this.today = year + '-' + mon + '-' + day

    var search = this.$route.params.search
    if (search !== undefined) {
      if (search.title !== undefined) {
        this.search = search
        this.query()
      } else {
        this.reset()
      }
    } else {
      this.reset()
    }
  },
  methods: {
    changeDate (e, type) {
      // 日期變更事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    keydownDate (e, type) {
      // 日期輸入事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    reset () {
      var date = new Date()
      var _date = new Date(date.setDate(date.getDate() - 90))
      var year = _date.getFullYear()
      var mon = _date.getMonth() + 1
      var day = _date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.search.sdate = year + '-' + mon + '-' + day
      this.search.edate = ''
      this.search.title = ''
      this.search.currentPage = 1
      this.sdateInvalid = false
      this.edateInvalid = false

      this.query()
    },
    btnQuery () {
      this.search.currentPage = 1
      this.query()
    },
    query (type) {
      this.isReSort = false
      var title, sdate, edate, status, page, pageRows

      if (type === 2) {
        title = ''
        sdate = ''
        edate = ''
        status = 1
        page = 1
        pageRows = 999
      } else {
        if (this.search.edate && this.search.sdate > this.search.edate) {
          miniToastr.error('查詢日期區間錯誤，請重新輸入')
          return
        }
        if (this.sdateInvalid || this.edateInvalid) {
          miniToastr.error('日期格式輸入錯誤，請重新輸入')
          return
        }
        title = this.search.title
        sdate = this.search.sdate
        edate = this.search.edate
        status = this.search.tabIndex === 1 ? 2 : 10
        page = this.search.currentPage
        pageRows = this.pageRows
      }

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/getpageadvertising/v1', {
        title: title,
        sdate: sdate,
        edate: edate,
        status: status,
        page: page,
        pageRows: pageRows
      })
        .then((response) => {
          // console.log(response.data)
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.totalRows = (response.data.count === undefined) ? 0 : response.data.count
            this.items = response.data.data
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.pageRows * (this.search.currentPage - 1) + 1;
            this.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.pageRows > response.data.count) ? response.data.count : (this.search.currentPage * this.pageRows) >= response.data.count ? response.data.count : this.search.currentPage * this.pageRows;
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            this.items = []
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.items = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    changeTab (val) {
      this.items = []
      this.search.currentPage = 1
      this.search.tabIndex = val
      this.query()
    },
    changePage (page) {
      this.search.currentPage = page
      this.query()
    },
    resort () {
      this.query(2)
      this.sort_list = []
      this.isReSort = true
    },
    dragEnd (e) {
      this.sort_list = []
      var childs = Array.from(e.to.getElementsByTagName("tr"))
      childs.forEach((value) => {
        this.sort_list.push(value.id)
      })
    },
    cancel () {
      if (this.sort_list.length === 0) {
        this.query()
      } else {
        this.sort_action = 1
        this.$refs.mdCheck.show()
      }
    },
    save () {
      if (this.sort_list.length === 0) {
        this.query()
      } else {
        this.sort_action = 2
        this.$refs.mdCheck.show()
      }
    },
    cancel2 () {
      this.$refs.mdCheck.hide()

      if (this.sort_action === 2) {
        this.query()
      }
    },
    confirm2 () {
      this.$refs.mdCheck.hide()

      if (this.sort_action === 1) {
        this.query()
      } else {
        this.$parent.Loading = true
        return axios.post(API_URL + '/web/marketing/resortadvertising/v1', {
          arrSort: this.sort_list
        })
          .then((response) => {
            this.$store.commit('TOKEN', response.data.jwt)
            this.$parent.Loading = false

            if (response.data.result === '0000') {
              miniToastr.success('首頁排序已變更')
              this.query()
            } else if (response.data.result === '0006') {
              this.$parent.logOut(true, true)
            } else {
              miniToastr.error(response.data.message, '資料變更錯誤')
              console.log(response.data.message)
            }
          })
          .catch((error) => {
            this.$parent.Loading = false
            miniToastr.error(error, '資料變更錯誤')
            console.log(error)
          })
      }
    },
    showDetail (item) {
      this.md_imgUrl = item.ImageURL
      this.$refs.mdDetail.show()
    },
    showDelete (item) {
      this.md_id = item.ID
      this.md_title = item.Title
      this.$refs.mdDelete.show()
    },
    delCancel () {
      this.$refs.mdDelete.hide()
    },
    delConfirm () {
      this.$refs.mdDelete.hide()

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/deleteadvertising/v1', {
        id: this.md_id
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('首頁廣告已刪除')
            this.query()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    }
  },
  filters: {
    formatDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var mon = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      return year + '/' + mon + '/' + day
    },
    formatFullDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var mon = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
      var min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
      var sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
      return year + '/' + mon + '/' + day + ' ' + hour + ':' + min + ':' + sec
    }
  }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move>tbody>tr {
  cursor: move;
}
.block {
  text-align: center;
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 53pt;
  left: 79pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 0;
}
.bk_img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/marketing/advertising/List.vue